import useDialogState from '@/hooks/use-dialog-state'
import { Attendant } from '@/interfaces/attendant'
import React, { useState } from 'react'

type AttendantsDialogType = 'create' | 'update' | 'delete'

interface AttendantsContextType {
  open: AttendantsDialogType | null
  setOpen: (str: AttendantsDialogType | null) => void
  currentRow: Attendant | null
  setCurrentRow: React.Dispatch<React.SetStateAction<Attendant | null>>
}

const AttendantsContext = React.createContext<AttendantsContextType | null>(null)

interface Props {
  children: React.ReactNode
}

export function AttendantsProvider({ children }: Props) {
  const [open, setOpen] = useDialogState<AttendantsDialogType>(null)
  const [currentRow, setCurrentRow] = useState<Attendant | null>(null)

  return (
    <AttendantsContext.Provider value={{ open, setOpen, currentRow, setCurrentRow }}>
      {children}
    </AttendantsContext.Provider>
  )
}

export const useAttendants = () => {
  const attendantsContext = React.useContext(AttendantsContext)

  if (!attendantsContext) {
    throw new Error('useAttendants has to be used within <AttendantsContext>')
  }

  return attendantsContext
} 